import Axios from "axios"
import {
  get
} from "lodash-es"
import { testMsg } from "."
// import systemAlert from "../utils/systemAlert"

export const testRequest = (config) => {
  if (
    config.method === 'put' ||
    config.method === 'delete' ||
    get(config, 'data.isTest') ||
    testRequestBlockApis.includes(config.url)
  ) {
    console.warn('API BLOCK : ', config)
    testMsg()
    throw new Axios.Cancel('Operation canceled by the user.');
  } else {
    // console.log('API PASS : ', config)
    return config
  }

}

const testRequestBlockApis = [

]